import { IServices } from "@netent/origin";
import { IVolumeState } from "@netent/playui";
import { FeatureStateCreator } from "../../types";

export const volumeState: FeatureStateCreator<IVolumeState> = (
  services: IServices
): IVolumeState => ({
  enabled: true,
  value: services.gameSettings.getSetting("volume"),
  muted: services.gameSettings.getSetting("volumeMute")
});
